import { Link } from "react-router-dom";
import { Clock, Users, ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { programs } from "../../mock/mock";

const ProgramsSection = () => {
  return (
    <section className="py-20 pattern-warm relative">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white shadow-sm border border-orange-100 mb-4">
            <span className="text-xs font-semibold text-orange-700 tracking-widest uppercase">Our Programs</span>
          </div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-stone-800 mb-4">
            Curated for Every <span className="text-orange-600">Little Learner</span>
          </h2>
          <p className="text-stone-600">
            Age-appropriate programs designed to nurture curiosity, creativity and cultural roots in children from 1.5 to 6 years.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {programs.map((p) => (
            <div
              key={p.id}
              className={`group ${p.color} rounded-3xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border border-white`}
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={p.image}
                  alt={p.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className={`absolute top-4 left-4 ${p.accent} text-white text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wider shadow-lg`}>
                  {p.name}
                </div>
              </div>
              <div className="p-6">
                <h3 className="font-display text-2xl font-bold text-stone-800 mb-3">{p.name}</h3>
                <p className="text-sm text-stone-600 mb-4 leading-relaxed line-clamp-3">{p.description}</p>
                <div className="flex items-center gap-4 mb-4 text-xs">
                  <div className="flex items-center gap-1.5 text-stone-700">
                    <Users className="w-3.5 h-3.5 text-orange-600" />
                    <span className="font-semibold">{p.ageGroup}</span>
                  </div>
                  <div className="flex items-center gap-1.5 text-stone-700">
                    <Clock className="w-3.5 h-3.5 text-orange-600" />
                    <span className="font-semibold">{p.duration}</span>
                  </div>
                </div>
                <div className="flex flex-wrap gap-1.5 mb-5">
                  {p.highlights.map((h, i) => (
                    <span key={i} className="text-[10px] font-medium bg-white text-stone-600 px-2 py-1 rounded-full border border-stone-200">
                      {h}
                    </span>
                  ))}
                </div>
                <Link to="/programs" className="inline-flex items-center gap-1 text-sm font-bold text-orange-700 hover:text-orange-800">
                  Learn More <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/admission">
            <Button size="lg" className="bg-gradient-to-r from-orange-600 to-amber-600 text-white rounded-full px-10 h-12 shadow-lg btn-shine">
              Book a Campus Visit
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProgramsSection;
